import { ICoreContext, IImageSettings } from '@msdyn365-commerce/core';

export function findImagesSettingsInProps(props: any, onFound: (result: IImageSettings) => void) {
    if (!props) {
        return;
    }
    Object.keys(props).forEach(key => {
        if (key === '_owner' || key === 'type' || key === 'tag' || key === 'requestContext') {
            return;
        }

        if (key === 'imageSettings') {
            onFound(props[key]);
        } else if (key === 'props' || key === 'children' || key === 'items' || key === 'Picture' || key.match(/^\d+$/m) && typeof props[key] === 'object') {
            findImagesSettingsInProps(props[key], onFound);
        }
    });
}

export function fixImageSettings(imageSettings: IImageSettings, removeSpecificImageSize: boolean = false, format: string = 'webp') {
    if (imageSettings.mode) {
        // How to set this otherwise it will overwrite modes defined below
        imageSettings.mode = 0;
    }

    Object.keys(imageSettings.viewports || {}).forEach(key => {
        const params = new URLSearchParams(imageSettings.viewports[key].q);

        params.set('f', format);
        params.set('m', '0');

        if (removeSpecificImageSize) {
            params.delete('w');
            params.delete('h');
        }

        imageSettings.viewports[key].q = params.toString();
    });
}

export function findAndFixImageSettingsInProps(props: any, removeSpecificImageSize: boolean = false) {
    findImagesSettingsInProps(props, (imageSettings: IImageSettings) => {
        fixImageSettings(imageSettings, removeSpecificImageSize);
    });
}

export function ensureBaseImageUrl(context: ICoreContext, imageUrl?: string) {
    if (!imageUrl) {
        return imageUrl;
    }

    let baseImageUrl = context.request.apiSettings.baseImageUrl || '';

    if (baseImageUrl.endsWith('/')) {
        baseImageUrl = baseImageUrl.slice(0, -1);
    }

    if (!imageUrl.startsWith('http') && !imageUrl.startsWith('/')) {
        imageUrl = `/${imageUrl}`;
    }

    if (!imageUrl.startsWith(context.request.apiSettings.baseImageUrl)) {
        imageUrl = baseImageUrl + imageUrl;
    }

    return imageUrl;
}
